import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { setGAUserId } from 'shared-utilities'
import { GA_TRACKING_ID, getCurrentEnv } from '../../config'

export const useGAUserTracking = () => {
  const { user, isAuthenticated, isLoading } = useAuth0()

  useEffect(() => {
    // Only track in STAGING and PROD environments
    const currentEnv = getCurrentEnv()
    if (currentEnv !== 'STAGING' && currentEnv !== 'PROD') return

    // Wait until auth is loaded
    if (isLoading) return

    // Set user_id if authenticated, clear it if not
    const userId = isAuthenticated && user?.sub ? user.sub : null
    setGAUserId(userId, GA_TRACKING_ID)
  }, [isAuthenticated, isLoading, user])
}
